import { useTranslation } from "react-i18next";

import { Stat, LoadingRows, ErrorState } from "./Panel";
import type { AnalyticsDashboard, AnalyticsViewProps } from "./types";

export function KpiRowView({ data, loading, error }: AnalyticsViewProps<AnalyticsDashboard>) {
  const { t } = useTranslation();
  if (loading) return <LoadingRows rows={1} />;
  if (error || !data) return <ErrorState message={t("homework.analytics.error")} />;

  const k = data.kpis;
  const pct = (v: number) => `${Math.round(v * 100)}%`;
  return (
    <div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label={t("homework.analytics.kpi.attendance")} value={pct(k.attendance_rate)} />
        <Stat label={t("homework.analytics.kpi.focus")} value={pct(k.focus_share)} />
        <Stat label={t("homework.analytics.kpi.openTasks")} value={String(k.open_tasks)} />
        <Stat label={t("homework.analytics.kpi.onLeave")} value={String(k.on_leave_today)} />
      </div>
      <p className="mt-2 text-[11px] text-muted-foreground">{data.caveat}</p>
    </div>
  );
}
